import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=f3288a5e&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3288a5e')) {
      api.createRecord('f3288a5e', component.options)
    } else {
      api.reload('f3288a5e', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=f3288a5e&", function () {
      api.rerender('f3288a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g0DFo5KmzGhd/JS/offershelp.vue"
export default component.exports